var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_cache2068",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols_cache2068"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_cache2068",
    d: "M24,11.1v1.7H8v-1.7c0-0.8,0.7-1.5,1.5-1.5h0.8V9.3c0-0.7,0.6-1.3,1.3-1.3l0,0 c0.7,0,1.3,0.6,1.3,1.3v0.3h6.4V9.3c0-0.7,0.6-1.3,1.3-1.3l0,0c0.7,0,1.3,0.6,1.3,1.3v0.3h0.8C23.3,9.6,24,10.3,24,11.1z M10,14.4 V22h12v-7.6h2v8.2c0,0.8-0.6,1.5-1.5,1.5H9.5C8.7,24,8,23.3,8,22.5v-8.2H10z M17.2,18l1.2,1.2c0.3,0.3,0.3,0.9,0,1.2 c-0.3,0.3-0.9,0.3-1.2,0L16,19.2l-1.2,1.2c-0.3,0.3-0.9,0.3-1.2,0c-0.3-0.3-0.3-0.9,0-1.2l1.2-1.2l-1.2-1.2 c-0.3-0.3-0.3-0.9,0-1.2c0.3-0.3,0.9-0.3,1.2,0l1.2,1.2l1.2-1.2c0.3-0.3,0.9-0.3,1.2,0c0.3,0.3,0.3,0.9,0,1.2L17.2,18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCalendar);
export default __webpack_public_path__ + "static/media/cancel-calendar.43862d8fb68286f2e64ede2ffb705ce5.svg";
export { ForwardRef as ReactComponent };